import { CustomerContact } from "./customer-contact";

export class Customer {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    updated_by_id!: number;
    name!: string;
    company_id!: string;
    email!: string;
    main_phone!: string;
    fax!: string;
    homepage!: string;
    notes!: string;
    street_address!: string;
    office!: string;
    city!: string;
    district!: string;
    postal_code!: string;
    mailing_street_address!: string;
    mailing_office!: string;
    mailing_city!: string;
    mailing_postal_code!: string;
    area_id!: number;
    responsible_id!: number;
    salary_rules_id!: number;
    lat!: string;
    long!: string;
    files!: any[];
    type!: string;
    contacts!: CustomerContact[];
    allow_ordering_with_invoice!: boolean;
    allow_ordering_with_cash!: boolean;
    requirements!: object;
    vat_id!: string;
    vat_valid!: boolean;
}
